module.exports = __webpack_public_path__ + "img/user.e77cad68.svg";